export const INIT_TRANSLATIONS = "INIT_TRANSLATIONS";
export const GET_TRANSLATION = "GET_TRANSLATION";
